import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { BtnPrimary } from "../../../share/buttons/Btn";
import EmptyCourseDash from "../../../share/EmptyCourseDash/EmptyCourseDash";
import Card from "../../../share/cards/Card";
import AdminPagination from "../../../share/Pageination/AdminPagination";
import { ReactComponent as Trash } from "../../../../Assets/Image/svg/trash.svg";
import { ReactComponent as Edit } from "../../../../Assets/Image/svg/edit.svg";
import { ReactComponent as Add } from "../../../../Assets/Image/svg/addSession.svg";
import { Modal } from "../../../share/modal/Modal";
import AddSession from "../../AdminCourseSessions/AddSession";
import IconButton from "../../../share/buttons/IconButton";
import { BsArrowLeft } from "react-icons/bs";
import { BsArrowRight } from "react-icons/bs";
import useFetch from "../../../../Hooks/useFetch";
import MainPagination from "../../../../Components/share/Pageination/MainPagination";
import { useCreate } from "../../../../Context/CreateContext";

const Sessions = (props) => {
    const { phaseStatus, setPhaseStatus, bootCamp } = useCreate();
    const [homework, setHomework] = useState();
    const [upload, setUpload] = useState(false);
    const [list, setList] = useState();
    const [del, setDel] = useState();
    const [edit, setEdit] = useState();
    const [pagination, setPagination] = useState({
        current: 1,
    });

    const handleModal = () => {
        setUpload((perv) => !perv);
    };

    const getSessions = useFetch({
        method: "GET",
        url: `BootCampSessionService/${bootCamp.id}/sessions`,
        pagination: pagination,
        noHeader: false,
        trigger: true,
        setter: setList,
    });

    const deleteSession = useFetch({
        method: "DELETE",
        url: `BootCampSessionService/${del}`,
        noHeader: false,
        caller: getSessions,
    });

    useEffect(() => {
        getSessions.reFetch();
    }, [pagination]);

    const handleDelete = (id) => {
        setDel(id);
        deleteSession.reFetch();
    };
    const handleEdit = (id) => {
        setEdit(id);
        setUpload((perv) => !perv);
    };

    console.log(list?.results);

    return (
        <>
            {list?.results.length !== 0 ? (
                <div className="p-16">
                    <div className="flex justify-between items-center">
                        <h4 className="text-[2rem] text-purple-dark font-bold">
                            اطلاعات جلسات بوت کمپ
                        </h4>
                        <BtnPrimary
                            text="+ ساخت جلسه جدید"
                            className="px-16 py-7"
                            onClick={() => handleModal()}
                        />
                    </div>
                    <div className="mx-24 py-24">
                        <Card className="SupportTicketTable-card SupportTicketTable-header ">
                            <div>نام جلسه</div>
                            <div></div>
                        </Card>
                        <div>
                            {list?.results?.map((i) => (
                                <Card
                                    key={i.id}
                                    className="SupportTicketTable-card SupportTicketTable-body my-4"
                                >
                                    <div className="text-black-prim">
                                        {i.session_name}
                                    </div>
                                    <div></div>
                                    <div className="mx-28">
                                        {!i.checked && (
                                            <div className="flex">
                                                <IconButton
                                                    data-tip="حذف"
                                                    onClick={() =>
                                                        handleDelete(i.id)
                                                    }
                                                >
                                                    <Trash />
                                                </IconButton>
                                                <IconButton
                                                    data-tip="ویرایش"
                                                    onClick={() =>
                                                        handleEdit(i.id)
                                                    }
                                                >
                                                    <Edit />
                                                </IconButton>
                                            </div>
                                        )}
                                    </div>
                                </Card>
                            ))}
                        </div>
                        <MainPagination
                            pagination={pagination}
                            setPagination={setPagination}
                            data={list?.results}
                            pageSize={list?.page_count}
                            className="mt-[3rem]"
                        />
                        <div className="flex  justify-between items-center mt-20">
                            <div
                                className="w-[20%] py-[15px] px-[35px] flex border-purple-dark text-purple-dark border-[1px] text-[1.8rem] rounded-[1.5rem] justify-around items-center cursor-pointer"
                                onClick={props.prevStep}
                            >
                                <span>مرحله قبل</span>
                                <BsArrowRight />
                            </div>
                            <div
                                className="w-[20%] py-[15px] px-[35px] flex border-purple-dark text-purple-dark border-[1px] text-[1.8rem] rounded-[1.5rem] justify-around items-center cursor-pointer"
                                onClick={props.nextStep}
                            >
                                <span>ثبت و ادامه</span>
                                <BsArrowLeft />
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <div>
                    <EmptyCourseDash name="جلسه" show={setUpload} />
                </div>
            )}
            <Modal show={upload} closeModal={handleModal} key={1}>
                <AddSession
                    getSessions={getSessions}
                    close={handleModal}
                    status={homework}
                    id={edit}
                    setId={setEdit}
                />
            </Modal>
        </>
    );
};

export default Sessions;
